import type { ReactionEventListener } from "../types";
import createCommonStore from "./common";
import createFormStore from "./form";
import createImagesStore from "./images";
import createNodeStore from "./node";
import createSwiperStore from "./swiper";

export const createStore = ({
  reactionEventListener,
}: {
  reactionEventListener: ReactionEventListener;
}) => {
  const commonStore = createCommonStore();
  const nodeStore = createNodeStore();
  const imagesStore = createImagesStore(nodeStore);
  const swiperStore = createSwiperStore();
  const formStore = createFormStore();

  const reset = () => {
    commonStore.reset();
    nodeStore.reset();
    imagesStore.reset();
    swiperStore.reset();
    formStore.reset();
  };

  return {
    ...commonStore.state,
    ...nodeStore.state,
    ...imagesStore.state,
    ...swiperStore.state,
    ...formStore.state,
    reactionEventListener,
    reset,
  };
};

export type Store = ReturnType<typeof createStore>;
